module.exports = __webpack_public_path__ + "static/media/profile-white.da52746a.svg";